const PortfolioDescription = () => {
  return (
    <section className="portfolio-text">
      <h2 className="title-font pink-text h2-tag">My Projects</h2>
      <p className="white-text p-tag">
        I have spent a lot of time on different projects based on my assignment.
        I love doing designing. Here are some of my favorite ones which sum up
        my knowledge. I have done many small projects from different courses and
        challenges to learn the basics.
        <span>
          {/* <a
            href="https://github.com/catherineisonline?tab=repositories"
            className="pink-text"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a> */}
        </span>
      </p>
    </section>
  );
};

export default PortfolioDescription;
